













































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Form as elForm } from "element-ui";
import axios, { resHandle } from "@/plugins/axios";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/model-left-nav.vue";
import modelClasses from "../my-model/modelClasses";
@Component({
  components: {
    Copy,
    MainHeader,
    LeftNav
  }
})
export default class CreateModel extends Vue {
  private modelClasses: any = modelClasses;
  private cState: "type" | "input" = "type";
  private model: any = {
    名称: "",
    类型: "辅助辨证模型"
  };
  private rules: any = {
    名称: [{ required: true, message: "模型名称必须填写", trigger: "blur" }],
    类型: [{ required: true, message: "模型类型必须填写", trigger: "blur" }]
  };
  /**
   * @description 开始创建模型
   */
  private createModel(type) {
    this.model["类型"] = type;
    this.cState = "input";
  }
  /**
   * @description 取消创建，返回类型选择
   */
  private cancel() {
    this.cState = "type";
  }
  /**
   * @description 保存
   */
  private save() {
    (this.$refs.inputForm as elForm).validate((isValid: boolean) => {
      if (isValid) {
        const params: any = {
          名称: this.model["名称"],
          类型: this.model["类型"],
          功能描述: this.model["功能描述"]
        };
        axios.post("api/model", params).then(({ data }) => {
          resHandle(this, data).then(() => {
            this.$message.success("创建成功");
            this.$router.push("/main/model/my-model");
          });
        });
      }
    });
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    // if (this.$route.params.type) {
    //   this.model["类型"] = this.$route.params.type;
    //   this.cState = "input";
    // }
  }
}
